import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'

loadFonts()

if (!localStorage.token) {
  localStorage.setItem('token', '')
}

// Configuración global de Axios
axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT || 'http://localhost:3001/api/v1/'
axios.defaults.headers = {
  token: localStorage.getItem('token')
}

const app = createApp(App)

// Agrega Axios como una propiedad global
app.config.globalProperties.$axios = axios

app.use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
